export default __webpack_public_path__ + "static/media/fileLogo.2ec0f0b6.svg";